import { RoleInfo, RoleResponse } from '../services/api';

/** Default agency role assigned via WorkOS; not shown in user-facing role pickers. */
export const HIDDEN_USER_ROLE_SLUGS: readonly string[] = ['member'] as const;

/** Permission slug for users assignable as visit clinicians (mirrors backend). */
export const CLINIC_ASSIGNABLE_CLINICIAN_PERMISSION =
  'clinic:assignable-as-clinician';

/** System role slug for assignable-as-clinician (mirrors backend). */
export const CLINIC_CLINICIAN_ROLE_SLUG = 'clinic:clinician';

export function isUserVisibleRole(role: RoleResponse | RoleInfo): boolean {
  return !HIDDEN_USER_ROLE_SLUGS.includes(role.slug);
}

export function filterUserVisibleRoles<T extends RoleResponse | RoleInfo>(
  roles: T[]
): T[] {
  return roles.filter(isUserVisibleRole);
}

/** This agency's own agency-scoped roles that a user may be given. */
export function filterAssignableAgencyRoles(
  roles: RoleResponse[]
): RoleResponse[] {
  return filterUserVisibleRoles(
    roles.filter(role => role.scope === 'agency' && role.is_internal !== true)
  );
}

export function isAssignableClinicianRole(role: RoleResponse): boolean {
  if (role.slug === CLINIC_CLINICIAN_ROLE_SLUG) return true;
  return (
    role.permissions?.some(
      permission => permission.slug === CLINIC_ASSIGNABLE_CLINICIAN_PERMISSION
    ) ?? false
  );
}
